export const NETWORK_ERROR = Symbol.for("network.error");
export const NETWORK_START = Symbol.for("network.start");
export const NETWORK_STOP = Symbol.for("network.stop");
export const SIGN_IN = Symbol.for("network.auth-sign-in");
export const SIGN_OUT = Symbol.for("network.auth-sign-out");
export const SIGN_OUT_SOFT = Symbol.for("network.auth-sign-out-soft");
